// extracted by mini-css-extract-plugin
var _1 = "CardBanner-module__banner--hvvNj";
export { _1 as "banner" }
